import { __ } from '@99designs/i18n';
import { getDesignProductPresenters } from '../../../products/';
import {
    getDefaultCategories,
    localisedBaseCategories,
    localisedPackagingCategories,
} from './categoriesConfig';
import type { SupportedLocale } from '@99designs/i18n';
import type { Category } from './categoriesConfig';

export type LocalisedCategory = Record<SupportedLocale, Category[]>;

type ParentCategoryKey = 'base' | 'packaging';

export const useCategoriesConfig = (
    locale: SupportedLocale,
    parentCategory: ParentCategoryKey = 'base'
): Category[] => {
    const productPresenters = getDesignProductPresenters(locale);
    const categories = getDefaultCategories(productPresenters);
    const parentCategories: Record<ParentCategoryKey, LocalisedCategory> = {
        base: { ...localisedBaseCategories(categories, productPresenters) },
        packaging: { ...localisedPackagingCategories(categories) },
    };

    return parentCategories[parentCategory][locale];
};
